import { render, staticRenderFns } from "./footer-navi.vue?vue&type=template&id=4f27f3c2&scoped=true"
import script from "./footer-navi.vue?vue&type=script&lang=ts"
export * from "./footer-navi.vue?vue&type=script&lang=ts"
import style0 from "./footer-navi.vue?vue&type=style&index=0&id=4f27f3c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f27f3c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VDialog,VDivider,VIcon,VSpacer,VToolbar})
